module.exports = __webpack_public_path__ + "img/casino-bota.b42ae24b.jpg";